import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { OperatingStatus } from '@/enum';

var AddEditMappingModal = function (_super) {
  __extends(AddEditMappingModal, _super);

  function AddEditMappingModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.saveLoading = false;
    _this.countryList = [];
    _this.formData = _this.initFormData();
    _this.formDataRule = {
      shop_code: [{
        required: true,
        message: _this.t('请选择店铺'),
        trigger: 'change'
      }],
      country_code_list: [{
        required: true,
        type: 'array',
        message: _this.t('请选择业务发生国'),
        trigger: 'change'
      }]
    };
    return _this;
  }

  AddEditMappingModal.prototype.onDataChange = function (data) {
    if (Object.keys(data || {}).length) {
      this.formData = {
        id: data.id,
        shop_code: data.shop_code,
        account_code: data.account_code,
        country_code_list: (data.country_list || []).map(function (item) {
          return item.country_code;
        }),
        bind_body_text: data.account_code ? data.account_code + "-" + (data.sign_body_name || '') : '',
        is_default: this.isEdit ? this.$enum.common.BoolIntEnum.YES : data.is_default
      };

      if (data.account_code) {
        this.queryCountryList(data.account_code);
      }
    } else {
      this.formData = this.initFormData();
      this.countryList = [];
    }
  };

  AddEditMappingModal.prototype.onVisibleChange = function (value) {
    if (!value) {
      var formDataRef = this.$refs.formDataRef;
      this.formData = this.initFormData();
      this.countryList = [];
      formDataRef && formDataRef.resetFields();
    }
  };

  Object.defineProperty(AddEditMappingModal.prototype, "title", {
    get: function get() {
      return this.mode === OperatingStatus.edit ? this.t('编辑映射配置') : this.t('新增店铺-国家映射配置');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AddEditMappingModal.prototype, "isEdit", {
    get: function get() {
      return this.mode === OperatingStatus.edit;
    },
    enumerable: false,
    configurable: true
  });

  AddEditMappingModal.prototype.initFormData = function () {
    return {
      shop_code: undefined,
      account_code: undefined,
      country_code_list: [],
      bind_body_text: '',
      is_default: this.$enum.common.BoolIntEnum.YES
    };
  };

  AddEditMappingModal.prototype.handleShopChange = function (shopCode) {
    var shop = this.shopList.find(function (item) {
      return item.shop_code === shopCode;
    });
    this.formData.account_code = shop === null || shop === void 0 ? void 0 : shop.account_code;
    this.formData.bind_body_text = this.formData.account_code ? shop.account_code + "-" + shop.sign_body_name : '';
    this.formData.country_code_list = [];

    if (shop === null || shop === void 0 ? void 0 : shop.account_code) {
      this.queryCountryList(shop.account_code);
    } else {
      this.countryList = [];
    }
  };

  AddEditMappingModal.prototype.queryCountryList = function (accountCode) {
    return __awaiter(this, void 0, Promise, function () {
      var isAdd, _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            isAdd = this.isEdit ? this.$enum.common.BoolIntEnum.NO : this.$enum.common.BoolIntEnum.YES;
            return [4, this.$api.shopManage.getSignBodyCountryDetail({
              account_code: accountCode,
              is_add: isAdd
            })];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.countryList = Array.isArray(data) ? data : [];
            return [2];
        }
      });
    });
  };

  AddEditMappingModal.prototype.buildPayload = function () {
    var base = {
      country_code_list: this.formData.country_code_list,
      is_default: this.formData.is_default,
      confirm_replace_default: false
    };
    return this.mode === OperatingStatus.edit ? __assign({
      id: this.formData.id
    }, base) : __assign({
      shop_code: this.formData.shop_code
    }, base);
  };

  AddEditMappingModal.prototype.submit = function (payload) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(this.mode === OperatingStatus.edit)) return [3, 2];
            return [4, this.$api.shopManage.editMapping(payload)];

          case 1:
            return [2, _a.sent()];

          case 2:
            return [4, this.$api.shopManage.addMapping(payload)];

          case 3:
            return [2, _a.sent()];
        }
      });
    });
  };

  AddEditMappingModal.prototype.handleOk = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      return __awaiter(_this, void 0, void 0, function () {
        var payload, res;

        var _this = this;

        var _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!valid) {
                return [2];
              }

              payload = this.buildPayload();
              this.saveLoading = true;
              _b.label = 1;

            case 1:
              _b.trys.push([1,, 3, 4]);

              return [4, this.submit(payload)];

            case 2:
              res = _b.sent();

              if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.need_confirm) {
                this.$confirm({
                  title: this.t('替换默认主体确认'),
                  content: res.message || this.t('该业务发生国下已存在默认结算主体，确认替换？'),
                  okText: this.t('确认替换'),
                  okType: 'warning',
                  onOk: function onOk() {
                    return __awaiter(_this, void 0, void 0, function () {
                      var reRes;

                      var _a;

                      return __generator(this, function (_b) {
                        switch (_b.label) {
                          case 0:
                            return [4, this.submit(__assign(__assign({}, payload), {
                              confirm_replace_default: true
                            }))];

                          case 1:
                            reRes = _b.sent();

                            if (!((_a = reRes.data) === null || _a === void 0 ? void 0 : _a.need_confirm)) {
                              this.$message.success(this.t('操作成功'));
                              this.visible = false;
                              this.$emit('success');
                            }

                            return [2];
                        }
                      });
                    });
                  }
                });
              } else {
                this.$message.success(this.t('操作成功'));
                this.visible = false;
                this.$emit('success');
              }

              return [3, 4];

            case 3:
              this.saveLoading = false;
              return [7];

            case 4:
              return [2];
          }
        });
      });
    });
  };

  __decorate([Prop({
    type: String,
    "default": OperatingStatus.add
  })], AddEditMappingModal.prototype, "mode", void 0);

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], AddEditMappingModal.prototype, "data", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], AddEditMappingModal.prototype, "shopList", void 0);

  __decorate([Watch('data')], AddEditMappingModal.prototype, "onDataChange", null);

  __decorate([Watch('visible')], AddEditMappingModal.prototype, "onVisibleChange", null);

  AddEditMappingModal = __decorate([Component], AddEditMappingModal);
  return AddEditMappingModal;
}(Vue);

export default AddEditMappingModal;